import { ADD_CLIENT, ADD_NOTICE, CLIENT_DATA, CLIENT_DETAILS, NOTICE_DATA, NOTICE_DETAILS, ADD_PROJECT_DATA, ADD_CUSTOMER_DATA, CUSTOMER_LIST, ADD_DESIGNATION_DATA, EMAIL_DATA } from "./ActionType";

const initialValue = {
    addClient: [],
    clientDetails: [],
    clientDataById: [],
    addNotice: [],
    noticeDetails: [],
    noticeDataById: [],
    addProject: [],
    customerlist: [],
    addcustomerdata: [],
    adddesingationdata: [],
    emaildata: [],
   
}

export const configReducer = (store = initialValue, { type, payload }) => {

    if (type === ADD_CLIENT) {
        return {
            ...store, addClient: payload || [],
        };
    } else if (type === CLIENT_DETAILS) {
        return {
            ...store, clientDetails: payload || [],
        };
    } else if (type === CLIENT_DATA) {
        return {
            ...store, clientDataById: payload || [],
        };
    } else if (type === ADD_NOTICE) {
        return {
            ...store, addNotice: payload || [],
        };
    } else if (type === NOTICE_DETAILS) {
        return {
            ...store, noticeDetails: payload.noticeDtoList || [],
        };
    } else if (type === NOTICE_DATA) {
        return {
            ...store, noticeDataById: payload || [],
        };
    } else if (type === ADD_PROJECT_DATA) {
        return {
            ...store,
            addProject: payload
        };
    } else if (type === ADD_CUSTOMER_DATA) {
        return {
            ...store,
            addcustomerdata: payload
        };
    } else if (type === CUSTOMER_LIST) {
        return {
            ...store,
            customerlist: Array.isArray(payload) ? payload : [],
        };
    } else if (type === ADD_DESIGNATION_DATA) {
        return {
            ...store,
            adddesingationdata: payload
        };
    }else if (type === EMAIL_DATA) {
        return {
            ...store,
            emaildata: Array.isArray(payload) ? payload : [],
        };
    }

    return store
}